export enum ContactMethodEnum {
  email = 1,
  phoneNumber = 2
}
